import { Nullable } from "../../base-types";
import Guard from "../../guard";

export interface ISearchAfterResult<T = unknown> {
    items: Array<T>;
    totalItems: number;
    returnedItems: number;
    lastHitData?: Nullable<Array<string>>;
}

export abstract class SearchAfterResultBase<T> implements ISearchAfterResult<T> {
    abstract items: Array<T>;

    totalItems: number;
    returnedItems: number;
    lastHitData?: Nullable<Array<string>>;

    constructor(totalItems: number, returnedItems: number, lastHitData?: Nullable<Array<string>>) {
        Guard.notNegative(totalItems);
        Guard.notNegative(returnedItems);

        this.totalItems = totalItems;
        this.returnedItems = returnedItems;
        this.lastHitData = lastHitData;
    }
}
